module.exports = __webpack_public_path__ + "static/p06_back-24e5e56b90c9391d7a09096776b471c2.jpg";